import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function FloatingContactButton() {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // WhatsApp link with your number
    const whatsappUrl = 'https://wa.me/19862756854?text=Hola!%20Tengo%20preguntas%20sobre%2030%20Noches%20para%20Dormir%20en%20Paz';
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };
  return <button onClick={handleClick} className="fixed bottom-6 right-6 z-[9999] bg-green-500 text-white rounded-full p-4 shadow-2xl hover:scale-110 transition-transform duration-300 hover:bg-green-600 group cursor-pointer" aria-label="Contactar por WhatsApp" type="button" data-id="element-110">
      <MessageCircleIcon className="w-6 h-6 animate-pulse" data-id="element-111" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-navy-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-112">
        ¿Tienes preguntas? 💬
      </span>
    </button>;
}